import {
  Paper,
  Title,
  Text,
  SimpleGrid,
  NumberFormatter,
  Box,
} from "@mantine/core";
import {
  TInsuranceElement as IInsuranceElement,
  TInsurance,
} from "../../hooks/api/useGetInsuranceById";
import InsuranceAssetOverview from "../insuranceAssetOverview";
import classes from "./index.module.css";

// Placeholder component for OLD type elements
const OldElementComponent = ({
  element,
  insurance,
}: {
  element: IInsuranceElement;
  insurance: TInsurance;
}) => (
  <Paper
    px={"lg"}
    py={{ base: "1rem", sm: "2rem" }}
    radius={"lg"}
    mb={"lg"}
    className={classes.insuranceListItemPaper}
  >
    <Title order={4} mb={0} ff={"var(--wallet-font-family-sambla-sans)"}>
      Ålderspension
    </Title>
    <SimpleGrid
      cols={{ base: 2, sm: 4 }}
      spacing={{ base: "md", sm: "lg" }}
      mt="xl"
    >
      <Text>
        <strong>Utbetalningstid:</strong>
      </Text>
      <Text>
        <NumberFormatter
          value={element.paymentPeriod / 12}
          decimalScale={0}
          suffix=" år"
        />
      </Text>
      <Text>
        <strong>Förvaltningsform:</strong>
      </Text>
      <Text>{insurance.managementType}</Text>
      <Text>
        <strong>Har premie­befrielse:</strong>
      </Text>
      <Text>{element.hasPbf ? "Ja" : "Nej"}</Text>
      <Text>
        <strong>Typ:</strong>
      </Text>
      <Text>
        {element.taxClass === "T" ? "Tjänstepension" : "Privatpension"}
      </Text>
    </SimpleGrid>
    <Box
      mt="xl"
      mb="xs"
      style={{ borderBottom: "1px solid var(--mantine-color-gray-1)" }}
    />

    {element?.eventNodes[0]?.assets ? (
      <InsuranceAssetOverview assets={element?.eventNodes[0]?.assets} />
    ) : null}
  </Paper>
);

export default OldElementComponent;
